// Crash reporting FIRST — before App is imported.
//
// ES module imports run in source order, so this side-effect import completes
// before `@/App` is evaluated. That ordering is the point: a crash while App's
// module graph initialises — a missing native module, an import-time throw — is
// exactly the launch crash that got v1.9.0 rejected under Broken Functionality,
// and it happens before any component renders. Init inside App would be too late
// to catch it.
import "@/sentry";

import { registerRootComponent } from "expo";

import App from "@/App";

registerRootComponent(App);
